import React, { useState } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import useInputState from '../../hooks/useInputState';
import Form, { FORM_BUTTON_TYPES, FORM_INPUT_TYPES } from '../../ui-kit/Form';
import BuildingImage from '../../assets/images/Building.png';
import useTranslations from '../../hooks/useTranslations';
import { DICTIONARY } from '../../translations/dictionary';
import sendRequest from '../../helpers/sendRequest';
import Api from '../../api';
import LocalStorageServices from '../../services/LocalStorageServices';
import { profileAtom, tokenAtom } from '../../atoms/accountAtoms';
import { openInfoModalAtom } from '../../atoms/modalAtoms';
import { windowHeightAtom, windowWidthAtom } from '../../atoms/globalAtoms';
import PasswordServices from '../../services/PasswordServices';

function SetNewPassword() {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const [profile] = useAtom(profileAtom);
  const [token, setToken] = useAtom(tokenAtom);
  const [windowHeight] = useAtom(windowHeightAtom);
  const [windowWidth] = useAtom(windowWidthAtom);
  const [, openInfoModal] = useAtom(openInfoModalAtom);
  // const [email, setEmail, emailError, setEmailError] = useInputState('');
  const [password, setPassword, passwordError, setPasswordError] = useInputState('');
  const [newPassword, setNewPassword, newPasswordError, setNewPasswordError] = useInputState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (ev) => {
    ev.preventDefault();

    let flag = false;
    if (!password) {
      setPasswordError('Заполните пароль');
      flag = true;
    }
    const err = PasswordServices.hasValidationError(password);
    if (err) {
      setPasswordError(err);
      flag = true;
    }
    if (password !== newPassword) {
      setNewPasswordError(t(DICTIONARY.passwordsNotMatch));
      flag = true;
    }
    if (flag) return;

    const data = await sendRequest({
      request: Api.setNewPassword,
      payload: { password, password_confirmation: newPassword },
      warnErrorText: 'while setting new password',
      setLoading,
    });

    if (data?.status === 'ok') {
      openInfoModal({ text: data?.message });
      LocalStorageServices.removeToken();
      setToken('');
    } else if (data?.data) {
      handleErrors(data.data);
    }
  };

  const handleErrors = (data) => {
    if (Array.isArray(data?.password)) setPasswordError(data.password.join('. '));
    if (Array.isArray(data?.password_confirmation)) setNewPasswordError(data.password_confirmation.join('. '));
  };

  const inputs = [
    {
      componentType: FORM_INPUT_TYPES.input,
      name: 'email',
      text: t(DICTIONARY.emailInputLabel),
      value: profile?.email,
      onChange: () => {},
      disabled: true,
    },
    {
      componentType: FORM_INPUT_TYPES.input,
      name: 'password',
      text: t(DICTIONARY.newPassword),
      value: password,
      onChange: setPassword,
      isRequired: true,
      error: passwordError,
      type: 'password',
    },
    {
      componentType: FORM_INPUT_TYPES.input,
      name: 'password',
      text: t(DICTIONARY.confirmNewPassword),
      value: newPassword,
      onChange: setNewPassword,
      isRequired: true,
      error: newPasswordError,
      type: 'password',
    },
  ];

  const buttons = [
    {
      componentType: FORM_BUTTON_TYPES.main,
      text: t(DICTIONARY.restore),
      type: 'submit',
      isDisabled: loading,
    },
    {
      componentType: FORM_BUTTON_TYPES.underlined,
      text: t(DICTIONARY.toLogin),
      onClick: () => {
        navigate('/login');
      },
    },
    {
      componentType: FORM_BUTTON_TYPES.underlined,
      text: t(DICTIONARY.registration),
      onClick: () => {
        navigate('/registration');
      },
    },
  ];

  return (
    <div className={styles.authorization}>
      <div className={classNames('container')}>
        <div className={styles.authorizationInner}>
          <Form
            title={t(DICTIONARY.enterPasswordFormTitle)}
            subtitle={t(DICTIONARY.passwordFormSubTitle)}
            inputs={inputs}
            buttons={buttons}
            onSubmit={onSubmit}
            source={BuildingImage}
            maxHeight={Math.min(windowWidth * 0.48, windowHeight < 750 ? 400 : Infinity)}
          />
        </div>
      </div>
    </div>
  );
}

export default SetNewPassword;
